import * as React from 'react';
import { getCookie } from '@utiljs/cookie';
import { getUrlParam } from '@utiljs/param';
import { getToken } from './api';

const env: any = getEnv();

function getHost() {
    const urlMap: any = {
        develop: 'http://invoice.waimai.test.sankuai.com',
        qa: 'http://invoice.waimai.test.sankuai.com',
        stage: 'https://invoice.waimai.st.sankuai.com',
        master: 'https://invoice.waimai.meituan.com',
    };
    return urlMap[env] ? urlMap[env] : urlMap.master;
}

function getEnv() {
    const url = window.location.href;
    if (url.includes('test.')) return 'qa';
    if (url.includes('st.')) return 'stage';
    return 'master';
}

const Invoice: React.FC = () => {
    const [epassToken, setEpassToken] = React.useState<string>('');
    React.useEffect(() => {
        getToken().then(res => {
            setEpassToken(res.data.epassToken);
        });
    }, []);

    if (!epassToken) {
        return null;
    }

    const getUrlLink = () => {
        const type = getUrlParam('type', window.location.href);
        console.log('urlParams', type);
        if (type === 'submit') {
            // 提交发票的场景
            const payBillId = getUrlParam('payBillId', window.location.href);
            return `${getHost()}/invoicefe/editInvoice?source=307&bizAcctId=${getCookie(
                'serviceProviderID',
            )}&token=${epassToken}&payBillId=${payBillId}`;
        }
        // 申请开票的场景
        return `${getHost()}/financefe#/invoice-apply/qualification-select?bizAcctId=${getCookie(
            'serviceProviderID',
        )}&token=${epassToken}&source=9`;
    };

    const urlSrc = getUrlLink();

    return <iframe src={urlSrc} frameBorder="no" width="100%" height="100%" />;
};

export default Invoice;
